module.exports = __webpack_public_path__ + "img/pc_p3_x3.b29a3788.svg";